var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "grid-view" },
    [
      _c("div", { staticClass: "main-content" }, [
        _c(
          "div",
          {
            staticClass: "app-main-inner-row",
            staticStyle: { "padding-top": "10px" }
          },
          [
            _vm.$store.getters.isGroupCompany
              ? _c(
                  "div",
                  { staticClass: "filters" },
                  [
                    _c(
                      "el-form",
                      {
                        attrs: {
                          inline: true,
                          "label-width": "80px",
                          "label-position": "left"
                        },
                        nativeOn: {
                          submit: function($event) {
                            $event.preventDefault()
                          }
                        }
                      },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_SelectBranch")
                            }
                          },
                          [
                            _c(
                              "el-select",
                              {
                                ref: "select",
                                staticStyle: { width: "218px" },
                                attrs: { multiple: "", filterable: "" },
                                on: {
                                  change: _vm.changeOfficeHandler,
                                  "visible-change": _vm.onVisibleChange
                                },
                                model: {
                                  value: _vm.branchIds,
                                  callback: function($$v) {
                                    _vm.branchIds = $$v
                                  },
                                  expression: "branchIds"
                                }
                              },
                              [
                                _c("el-option", {
                                  attrs: {
                                    value: 0,
                                    label: _vm.$t("Message.All")
                                  }
                                }),
                                _vm._l(_vm.currentOfficeList, function(office) {
                                  return _c("el-option", {
                                    key: office.uuid,
                                    attrs: {
                                      value: office.officeId,
                                      label: office.code
                                    }
                                  })
                                })
                              ],
                              2
                            ),
                            _c(
                              "el-button",
                              {
                                staticStyle: { "margin-left": "5px" },
                                attrs: { size: "mini", type: "primary" },
                                on: { click: _vm.showBranchSelectDialog }
                              },
                              [_vm._v("...")]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "div",
              { staticClass: "triggers" },
              [
                _c("span", [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Search")))]),
                _c("el-input", {
                  staticStyle: { width: "200px", margin: "0 10px" },
                  attrs: { placeholder: _vm.$t("common.tips.fuzzySearch") },
                  on: {
                    input: function($event) {
                      return _vm.toQuery({
                        likeName: _vm.keyword,
                        pageNum: 1,
                        officeId: _vm.branchIds
                      })
                    }
                  },
                  model: {
                    value: _vm.keyword,
                    callback: function($$v) {
                      _vm.keyword = $$v
                    },
                    expression: "keyword"
                  }
                }),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: {
                      click: function($event) {
                        return _vm.showEditDialog(true)
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("common.btn.new")))]
                ),
                _c(
                  "el-button",
                  { attrs: { type: "primary" }, on: { click: _vm.onCopy } },
                  [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Copy")))]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: {
                      click: function($event) {
                        return _vm.showEditDialog(false)
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("common.btn.edit")))]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { size: "mini", type: "danger" },
                    on: { click: _vm.remove }
                  },
                  [_vm._v(_vm._s(_vm.$t("common.btn.delete")))]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { size: "mini", type: "primary" },
                    on: {
                      click: function($event) {
                        _vm.manualFilter.reload = true
                        _vm.toQuery({
                          likeName: _vm.keyword,
                          pageNum: 1,
                          officeId: _vm.branchIds
                        })
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("common.btn.refresh")))]
                )
              ],
              1
            )
          ]
        ),
        _c(
          "div",
          { staticClass: "section grid-wrapper" },
          [
            _c("cargo-ag-grid", {
              attrs: {
                "config-module": "200101",
                "grid-params": _vm.girdParams,
                "grid-options": _vm.gridOptions,
                "column-defs": _vm.columnDefs,
                "row-data": _vm.rowData
              },
              on: {
                "update:gridParams": function($event) {
                  _vm.girdParams = $event
                },
                "update:grid-params": function($event) {
                  _vm.girdParams = $event
                }
              }
            })
          ],
          1
        ),
        _c(
          "div",
          [
            _c("cargo-pagination", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.total > 0,
                  expression: "total>0"
                }
              ],
              attrs: {
                total: _vm.total,
                page: _vm.filter.pageNum,
                limit: _vm.filter.pageSize
              },
              on: {
                "update:page": function($event) {
                  return _vm.$set(_vm.filter, "pageNum", $event)
                },
                "update:limit": function($event) {
                  return _vm.$set(_vm.filter, "pageSize", $event)
                },
                pagination: function($event) {
                  _vm.manualPage.paginationClick = true
                  _vm.toQuery()
                }
              }
            })
          ],
          1
        )
      ]),
      _c(
        "form",
        {
          ref: "reportForm",
          staticStyle: { display: "none" },
          attrs: { action: _vm.report.url, target: "_blank", method: "post" }
        },
        _vm._l(_vm.report.formEntries, function(item) {
          return _c("input", {
            key: decodeURIComponent(item[0]),
            attrs: { name: decodeURIComponent(item[0]) },
            domProps: { value: decodeURIComponent(item[1]) }
          })
        }),
        0
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.editDialog.visible,
            title: _vm.editDialog.title,
            width: "400px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.editDialog, "visible", $event)
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "app-main-inner-row",
              staticStyle: { "padding-bottom": "10px" }
            },
            [
              _c(
                "el-form",
                { attrs: { "label-width": "110px", "label-position": "left" } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "SystemMaintenance.AdditionalOutputAssociatedTemplate"
                        )
                      }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { disabled: _vm.editDialog.form.engine === 0 },
                          on: { focus: _vm.coverTemplateFocus },
                          model: {
                            value: _vm.editDialog.form.coverTemplateUuid,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.editDialog.form,
                                "coverTemplateUuid",
                                $$v
                              )
                            },
                            expression: "editDialog.form.coverTemplateUuid"
                          }
                        },
                        _vm._l(_vm.coverTemplateList, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: { label: item.name, value: item.uuid }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SystemMaintenance.FileClassification")
                      }
                    },
                    [
                      _c("cargo-advance-select", {
                        staticStyle: { width: "150px" },
                        attrs: {
                          cache: false,
                          filterable: "",
                          "default-value": _vm.editDialog.form.documentTypeUuid,
                          "static-options": _vm.documentTypeList,
                          "filter-type": "global",
                          "tag-name": "listShowName",
                          "tag-value": "uuid",
                          "filter-tag-names": ["listShowName"]
                        },
                        on: {
                          parentCallBack: function(p) {
                            return (_vm.editDialog.form.documentTypeUuid =
                              p.value)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SystemMaintenance.TemplateEngine")
                      }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          on: { change: _vm.engineChange },
                          model: {
                            value: _vm.editDialog.form.engine,
                            callback: function($$v) {
                              _vm.$set(_vm.editDialog.form, "engine", $$v)
                            },
                            expression: "editDialog.form.engine"
                          }
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "JasperReport", value: 0 }
                          }),
                          _c("el-option", {
                            attrs: { label: "StiReport", value: 1 }
                          }),
                          _c("el-option", { attrs: { label: "V3", value: 2 } })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("SystemMaintenance.FilterScript") }
                    },
                    [
                      _c("el-input", {
                        attrs: { "filter-chars": false },
                        model: {
                          value: _vm.editDialog.form.filter,
                          callback: function($$v) {
                            _vm.$set(_vm.editDialog.form, "filter", $$v)
                          },
                          expression: "editDialog.form.filter"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("CargoMsg.Cargo_PrintChannel") } },
                    [
                      _c(
                        "el-select",
                        {
                          model: {
                            value: _vm.editDialog.form.printChannel,
                            callback: function($$v) {
                              _vm.$set(_vm.editDialog.form, "printChannel", $$v)
                            },
                            expression: "editDialog.form.printChannel"
                          }
                        },
                        _vm._l(_vm.printCancelList, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: { label: item.chineseName, value: item.code }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("SystemMaintenance.TemplateName") }
                    },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.editDialog.form.name,
                          callback: function($$v) {
                            _vm.$set(_vm.editDialog.form, "name", $$v)
                          },
                          expression: "editDialog.form.name"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SystemMaintenance.BranchSerialNumber")
                      }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          model: {
                            value: _vm.editDialog.form.officeId,
                            callback: function($$v) {
                              _vm.$set(_vm.editDialog.form, "officeId", $$v)
                            },
                            expression: "editDialog.form.officeId"
                          }
                        },
                        _vm._l(_vm.officeList, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: {
                              label: item.chineseName,
                              value: item.officeId
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SystemMaintenance.Remark") } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.editDialog.form.remarks,
                          callback: function($$v) {
                            _vm.$set(_vm.editDialog.form, "remarks", $$v)
                          },
                          expression: "editDialog.form.remarks"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("SystemMaintenance.TemplateFile") }
                    },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.editDialog.form.templateFile,
                          callback: function($$v) {
                            _vm.$set(_vm.editDialog.form, "templateFile", $$v)
                          },
                          expression: "editDialog.form.templateFile"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SystemMaintenance.TemplateClass")
                      }
                    },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.editDialog.form.templateType,
                          callback: function($$v) {
                            _vm.$set(_vm.editDialog.form, "templateType", $$v)
                          },
                          expression: "editDialog.form.templateType"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SystemMaintenance.TemplateUsage")
                      }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          model: {
                            value: _vm.editDialog.form.templateUsage,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.editDialog.form,
                                "templateUsage",
                                $$v
                              )
                            },
                            expression: "editDialog.form.templateUsage"
                          }
                        },
                        [
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("SystemMaintenance.Printing"),
                              value: 0
                            }
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("SystemMaintenance.Email"),
                              value: 1
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.save } },
                [_vm._v(_vm._s(_vm.$t("common.btn.save")))]
              ),
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.editDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
              )
            ],
            1
          )
        ]
      ),
      _c("branch-select-dialog", {
        attrs: {
          visible: _vm.branchSelectDialog.visible,
          value: _vm.branchSelectDialog.value,
          "office-list": _vm.currentOfficeList
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.branchSelectDialog, "visible", $event)
          },
          callback: _vm.branchSelectDialog.callback
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }